import { render, staticRenderFns } from "./PaymentButton.vue?vue&type=template&id=307a0da0"
import script from "./PaymentButton.vue?vue&type=script&lang=js"
export * from "./PaymentButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports